import React from 'react'
import Hero from '../../components/Service/Servicesub/Graphicdesign/Hero'
import Description from '../../components/Service/Servicesub/Graphicdesign/Description'
import Technologies from '../../components/Service/Servicesub/Graphicdesign/Technologies'
import Number from '../../components/Service/Servicesub/Graphicdesign/Number'
const Graphicdesign = () => {
  return (
    <div>
            <Hero />
            <Description />
            <Technologies />
            <Number />
    </div>
  )
}

export default Graphicdesign
